const MuiCheckbox = {
    styleOverrides: {
        root: {
            borderRadius: '6px !important',
            height: '20px !important',
            width: '20px',
            border: '2px solid #979797'
        }
    }
};

export default MuiCheckbox;
